export const firebaseConfig = {
    apiKey: "AIzaSyD3g7j3EMfThx-_RdTKNRCr8ratHIU-IQc",
    authDomain: "caritas-quiz.firebaseapp.com",
    projectId: "caritas-quiz",
    storageBucket: "caritas-quiz.appspot.com",
    messagingSenderId: "228311724911",
    appId: "1:228311724911:web:ceacc2e0c46d1ad9b0ee9a"
};